export const phoneCodes = [
	{
		counryCode: 'AF',
		phoneCode: '+93',
		name: 'Afghanistan',
		currency: 'AFN'
	},
	{
		counryCode: 'AL',
		phoneCode: '+355',
		name: 'Albania',
		currency: 'ALL'
	},
	{
		counryCode: 'DZ',
		phoneCode: '+213',
		name: 'Algeria',
		currency: 'DZD'
	},
	{
		counryCode: 'AS',
		phoneCode: '+1684',
		name: 'American Samoa',
		currency: 'USD'
	},
	{
		counryCode: 'AD',
		phoneCode: '+376',
		name: 'Andorra',
		currency: 'EUR'
	},
	{
		counryCode: 'AO',
		phoneCode: '+244',
		name: 'Angola',
		currency: 'AOA'
	},
	{
		counryCode: 'AR',
		phoneCode: '+54',
		name: 'Argentina',
		currency: 'ARS'
	},
	{
		counryCode: 'AM',
		phoneCode: '+374',
		name: 'Armenia',
		currency: 'AMD'
	},
	{
		counryCode: 'AU',
		phoneCode: '+61',
		name: 'Australia',
		currency: 'AUD'
	},
	{
		counryCode: 'AT',
		phoneCode: '+43',
		name: 'Austria',
		currency: 'EUR'
	},
	{
		counryCode: 'AZ',
		phoneCode: '+994',
		name: 'Azerbaijan',
		currency: 'AZN'
	},
	{
		counryCode: 'BS',
		phoneCode: '+1242',
		name: 'Bahamas',
		currency: 'BSD'
	},
	{
		counryCode: 'BH',
		phoneCode: '+973',
		name: 'Bahrain',
		currency: 'BHD'
	},
	{
		counryCode: 'BD',
		phoneCode: '+880',
		name: 'Bangladesh',
		currency: 'BDT'
	},
	{
		counryCode: 'BB',
		phoneCode: '+1246',
		name: 'Barbados',
		currency: 'BBD'
	},
	{
		counryCode: 'BY',
		phoneCode: '+375',
		name: 'Belarus',
		currency: 'BYN',
		phoneFormat: '(##) ### ## ##',
		phonePlaceholder: '(29) 322 22 22'
	},
	{
		counryCode: 'BE',
		phoneCode: '+32',
		name: 'Belgium',
		currency: 'EUR'
	},
	{
		counryCode: 'BZ',
		phoneCode: '+501',
		name: 'Belize',
		currency: 'BZD'
	},
	{
		counryCode: 'BT',
		phoneCode: '+975',
		name: 'Bhutan',
		currency: 'BTN'
	},
	{
		counryCode: 'BO',
		phoneCode: '+591',
		name: 'Bolivia, Plurinational State Of',
		currency: 'BOB'
	},
	{
		counryCode: 'BQ',
		phoneCode: '+599',
		name: 'Bonaire, Saint Eustatius And Saba',
		currency: 'USD'
	},
	{
		counryCode: 'BA',
		phoneCode: '+387',
		name: 'Bosnia & Herzegovina',
		currency: 'BAM'
	},
	{
		counryCode: 'BW',
		phoneCode: '+267',
		name: 'Botswana',
		currency: 'BWP'
	},
	{
		counryCode: 'BR',
		phoneCode: '+55',
		name: 'Brazil',
		currency: 'BRL'
	},
	{
		counryCode: 'IO',
		phoneCode: '+246',
		name: 'British Indian Ocean Territory',
		currency: 'USD'
	},
	{
		counryCode: 'BN',
		phoneCode: '+673',
		name: 'Brunei Darussalam',
		currency: 'BND'
	},
	{
		counryCode: 'BG',
		phoneCode: '+359',
		name: 'Bulgaria',
		currency: 'BGN'
	},
	{
		counryCode: 'BI',
		phoneCode: '+257',
		name: 'Burundi',
		currency: 'BIF'
	},
	{
		counryCode: 'KH',
		phoneCode: '+855',
		name: 'Cambodia',
		currency: 'KHR'
	},
	{
		counryCode: 'CM',
		phoneCode: '+237',
		name: 'Cameroon',
		currency: 'XAF'
	},
	{
		counryCode: 'CA',
		phoneCode: '+1',
		name: 'Canada',
		currency: 'CAD'
	},
	{
		counryCode: 'CV',
		phoneCode: '+238',
		name: 'Cape Verde',
		currency: 'CVE'
	},
	{
		counryCode: 'CF',
		phoneCode: '+236',
		name: 'Central African Republic',
		currency: 'XAF'
	},
	{
		counryCode: 'TD',
		phoneCode: '+235',
		name: 'Chad',
		currency: 'XAF'
	},
	{
		counryCode: 'CL',
		phoneCode: '+56',
		name: 'Chile',
		currency: 'CLP'
	},
	{
		counryCode: 'CN',
		phoneCode: '+86',
		name: 'China',
		currency: 'CNY'
	},
	{
		counryCode: 'CX',
		phoneCode: '+61',
		name: 'Christmas Island',
		currency: 'AUD'
	},
	{
		counryCode: 'CC',
		phoneCode: '+61',
		name: 'Cocos (Keeling) Islands',
		currency: 'AUD'
	},
	{
		counryCode: 'CO',
		phoneCode: '+57',
		name: 'Colombia',
		currency: 'COP'
	},
	{
		counryCode: 'KM',
		phoneCode: '+269',
		name: 'Comoros',
		currency: 'KMF'
	},
	{
		counryCode: 'CK',
		phoneCode: '+682',
		name: 'Cook Islands',
		currency: 'NZD'
	},
	{
		counryCode: 'CR',
		phoneCode: '+506',
		name: 'Costa Rica',
		currency: 'CRC'
	},
	{
		counryCode: 'HR',
		phoneCode: '+385',
		name: 'Croatia',
		currency: 'HRK'
	},
	{
		counryCode: 'CU',
		phoneCode: '+53',
		name: 'Cuba',
		currency: 'CUP'
	},
	{
		counryCode: 'CW',
		phoneCode: '+599',
		name: 'Curacao',
		currency: 'ANG'
	},
	{
		counryCode: 'CY',
		phoneCode: '+357',
		name: 'Cyprus',
		currency: 'EUR'
	},
	{
		counryCode: 'CZ',
		phoneCode: '+420',
		name: 'Czech Republic',
		currency: 'CZK'
	},
	{
		counryCode: 'CD',
		phoneCode: '+243',
		name: 'Democratic Republic Of Congo',
		currency: 'CDF'
	},
	{
		counryCode: 'DK',
		phoneCode: '+45',
		name: 'Denmark',
		currency: 'DKK'
	},
	{
		counryCode: 'DJ',
		phoneCode: '+253',
		name: 'Djibouti',
		currency: 'DJF'
	},
	{
		counryCode: 'DO',
		phoneCode: '+1809',
		name: 'Dominican Republic',
		currency: 'DOP'
	},
	{
		counryCode: 'TL',
		phoneCode: '+670',
		name: 'East Timor',
		currency: 'USD'
	},
	{
		counryCode: 'EC',
		phoneCode: '+593',
		name: 'Ecuador',
		currency: 'USD'
	},
	{
		counryCode: 'EG',
		phoneCode: '+20',
		name: 'Egypt',
		currency: 'EGP'
	},
	{
		counryCode: 'SV',
		phoneCode: '+503',
		name: 'El Salvador',
		currency: 'USD'
	},
	{
		counryCode: 'GQ',
		phoneCode: '+240',
		name: 'Equatorial Guinea',
		currency: 'XAF'
	},
	{
		counryCode: 'ER',
		phoneCode: '+291',
		name: 'Eritrea',
		currency: 'ERN'
	},
	{
		counryCode: 'EE',
		phoneCode: '+372',
		name: 'Estonia',
		currency: 'EUR'
	},
	{
		counryCode: 'ET',
		phoneCode: '+251',
		name: 'Ethiopia',
		currency: 'ETB'
	},
	{
		counryCode: 'FO',
		phoneCode: '+298',
		name: 'Faroe Islands',
		currency: 'DKK'
	},
	{
		counryCode: 'FI',
		phoneCode: '+358',
		name: 'Finland',
		currency: 'EUR'
	},
	{
		counryCode: 'FR',
		phoneCode: '+33',
		name: 'France',
		currency: 'EUR'
	},
	{
		counryCode: 'GF',
		phoneCode: '+44',
		name: 'French Guiana',
		currency: 'EUR'
	},
	{
		counryCode: 'GA',
		phoneCode: '+44',
		name: 'Gabon',
		currency: 'XAF'
	},
	{
		counryCode: 'GM',
		phoneCode: '+220',
		name: 'Gambia',
		currency: 'GMD'
	},
	{
		counryCode: 'GE',
		phoneCode: '+594',
		name: 'Georgia',
		currency: 'GEL'
	},
	{
		counryCode: 'DE',
		phoneCode: '+49',
		name: 'Germany',
		currency: 'EUR'
	},
	{
		counryCode: 'GH',
		phoneCode: '+233',
		name: 'Ghana',
		currency: 'GHS'
	},
	{
		counryCode: 'GR',
		phoneCode: '+30',
		name: 'Greece',
		currency: 'EUR'
	},
	{
		counryCode: 'GL',
		phoneCode: '+299',
		name: 'Greenland',
		currency: 'DKK'
	},
	{
		counryCode: 'GP',
		phoneCode: '+590',
		name: 'Guadeloupe',
		currency: 'EUR'
	},
	{
		counryCode: 'GU',
		phoneCode: '+1671',
		name: 'Guam',
		currency: 'USD'
	},
	{
		counryCode: 'GT',
		phoneCode: '+502',
		name: 'Guatemala',
		currency: 'GTQ'
	},
	{
		counryCode: 'GN',
		phoneCode: '+224',
		name: 'Guinea',
		currency: 'GNF'
	},
	{
		counryCode: 'GY',
		phoneCode: '+592',
		name: 'Guyana',
		currency: 'GYD'
	},
	{
		counryCode: 'HT',
		phoneCode: '+509',
		name: 'Haiti',
		currency: 'HTG'
	},
	{
		counryCode: 'HN',
		phoneCode: '+504',
		name: 'Honduras',
		currency: 'HNL'
	},
	{
		counryCode: 'HU',
		phoneCode: '+36',
		name: 'Hungary',
		currency: 'HUF'
	},
	{
		counryCode: 'IS',
		phoneCode: '+354',
		name: 'Iceland',
		currency: 'ISK'
	},
	{
		counryCode: 'ID',
		phoneCode: '+62',
		name: 'Indonesia',
		currency: 'IDR'
	},
	{
		counryCode: 'IR',
		phoneCode: '+98',
		name: 'Iran, Islamic Republic Of',
		currency: 'IRR'
	},
	{
		counryCode: 'IQ',
		phoneCode: '+964',
		name: 'Iraq',
		currency: 'IQD'
	},
	{
		counryCode: 'IE',
		phoneCode: '+353',
		name: 'Ireland',
		currency: 'EUR'
	},
	{
		counryCode: 'IM',
		phoneCode: '+44',
		name: 'Isle Of Man',
		currency: 'GBP'
	},
	{
		counryCode: 'IL',
		phoneCode: '+972',
		name: 'Israel',
		currency: 'ILS'
	},
	{
		counryCode: 'IT',
		phoneCode: '+39',
		name: 'Italy',
		currency: 'EUR'
	},
	{
		counryCode: 'JM',
		phoneCode: '+1876',
		name: 'Jamaica',
		currency: 'JMD'
	},
	{
		counryCode: 'JP',
		phoneCode: '+81',
		name: 'Japan',
		currency: 'JPY'
	},
	{
		counryCode: 'JE',
		phoneCode: '+44',
		name: 'Jersey',
		currency: 'GBP'
	},
	{
		counryCode: 'JO',
		phoneCode: '+962',
		name: 'Jordan',
		currency: 'JOD'
	},
	{
		counryCode: 'KZ',
		phoneCode: '+7',
		name: 'Kazakhstan',
		currency: 'KZT'
	},
	{
		counryCode: 'KE',
		phoneCode: '+254',
		name: 'Kenya',
		currency: 'KES'
	},
	{
		counryCode: 'KI',
		phoneCode: '+686',
		name: 'Kiribati',
		currency: 'AUD'
	},
	{
		counryCode: 'KP',
		phoneCode: '+850',
		name: "Korea, Democratic People's Republic Of",
		currency: 'KPW'
	},
	{
		counryCode: 'KR',
		phoneCode: '+82',
		name: 'Korea, Republic Of',
		currency: 'KRW'
	},
	{
		counryCode: 'KW',
		phoneCode: '+965',
		name: 'Kuwait',
		currency: 'KWD'
	},
	{
		counryCode: 'KG',
		phoneCode: '+996',
		name: 'Kyrgyzstan',
		currency: 'KGS'
	},
	{
		counryCode: 'LA',
		phoneCode: '+856',
		name: "Lao People's Democratic Republic",
		currency: 'LAK'
	},
	{
		counryCode: 'LV',
		phoneCode: '+371',
		name: 'Latvia',
		currency: 'EUR'
	},
	{
		counryCode: 'LB',
		phoneCode: '+961',
		name: 'Lebanon',
		currency: 'LBP'
	},
	{
		counryCode: 'LS',
		phoneCode: '+266',
		name: 'Lesotho',
		currency: 'LSL'
	},
	{
		counryCode: 'LR',
		phoneCode: '+231',
		name: 'Liberia',
		currency: 'LRD'
	},
	{
		counryCode: 'LY',
		phoneCode: '+218',
		name: 'Libya',
		currency: 'LYD'
	},
	{
		counryCode: 'LI',
		phoneCode: '+423',
		name: 'Liechtenstein',
		currency: 'CHF'
	},
	{
		counryCode: 'LT',
		phoneCode: '+370',
		name: 'Lithuania',
		currency: 'EUR'
	},
	{
		counryCode: 'LU',
		phoneCode: '+352',
		name: 'Luxembourg',
		currency: 'EUR'
	},
	{
		counryCode: 'MO',
		phoneCode: '+853',
		name: 'Macao',
		currency: 'MOP'
	},
	{
		counryCode: 'MK',
		phoneCode: '+389',
		name: 'Macedonia, The Former Yugoslav Republic Of',
		currency: 'MKD'
	},
	{
		counryCode: 'MG',
		phoneCode: '+261',
		name: 'Madagascar',
		currency: 'MGA'
	},
	{
		counryCode: 'MW',
		phoneCode: '+265',
		name: 'Malawi',
		currency: 'MWK'
	},
	{
		counryCode: 'MY',
		phoneCode: '+60',
		name: 'Malaysia',
		currency: 'MYR'
	},
	{
		counryCode: 'MV',
		phoneCode: '+960',
		name: 'Maldives',
		currency: 'MVR'
	},
	{
		counryCode: 'MT',
		phoneCode: '+356',
		name: 'Malta',
		currency: 'EUR'
	},
	{
		counryCode: 'MH',
		phoneCode: '+692',
		name: 'Marshall Islands',
		currency: 'USD'
	},
	{
		counryCode: 'MQ',
		phoneCode: '+596',
		name: 'Martinique',
		currency: 'EUR'
	},
	{
		counryCode: 'MR',
		phoneCode: '+222',
		name: 'Mauritania',
		currency: 'MRU'
	},
	{
		counryCode: 'MU',
		phoneCode: '+230',
		name: 'Mauritius',
		currency: 'MUR'
	},
	{
		counryCode: 'YT',
		phoneCode: '+262',
		name: 'Mayotte',
		currency: 'EUR'
	},
	{
		counryCode: 'MX',
		phoneCode: '+52',
		name: 'Mexico',
		currency: 'MXN'
	},
	{
		counryCode: 'FM',
		phoneCode: '+691',
		name: 'Micronesia, Federated States Of',
		currency: 'USD'
	},
	{
		counryCode: 'MD',
		phoneCode: '+373',
		name: 'Moldova',
		currency: 'MDL'
	},
	{
		counryCode: 'MC',
		phoneCode: '+377',
		name: 'Monaco',
		currency: 'EUR'
	},
	{
		counryCode: 'MN',
		phoneCode: '+976',
		name: 'Mongolia',
		currency: 'MNT'
	},
	{
		counryCode: 'ME',
		phoneCode: '+382',
		name: 'Montenegro',
		currency: 'EUR'
	},
	{
		counryCode: 'MA',
		phoneCode: '+212',
		name: 'Morocco',
		currency: 'MAD'
	},
	{
		counryCode: 'MZ',
		phoneCode: '+258',
		name: 'Mozambique',
		currency: 'MZN'
	},
	{
		counryCode: 'MM',
		phoneCode: '+95',
		name: 'Myanmar',
		currency: 'MMK'
	},
	{
		counryCode: 'NA',
		phoneCode: '+264',
		name: 'Namibia',
		currency: 'NAD'
	},
	{
		counryCode: 'NR',
		phoneCode: '+674',
		name: 'Nauru',
		currency: 'AUD'
	},
	{
		counryCode: 'NP',
		phoneCode: '+977',
		name: 'Nepal',
		currency: 'NPR'
	},
	{
		counryCode: 'NL',
		phoneCode: '+31',
		name: 'Netherlands',
		currency: 'EUR'
	},
	{
		counryCode: 'NZ',
		phoneCode: '+64',
		name: 'New Zealand',
		currency: 'NZD'
	},
	{
		counryCode: 'NI',
		phoneCode: '+505',
		name: 'Nicaragua',
		currency: 'NIO'
	},
	{
		counryCode: 'NG',
		phoneCode: '+234',
		name: 'Nigeria',
		currency: 'NGN'
	},
	{
		counryCode: 'NU',
		phoneCode: '+683',
		name: 'Niue',
		currency: 'NZD'
	},
	{
		counryCode: 'NF',
		phoneCode: '+672',
		name: 'Norfolk Island',
		currency: 'AUD'
	},
	{
		counryCode: 'MP',
		phoneCode: '+1670',
		name: 'Northern Mariana Islands',
		currency: 'USD'
	},
	{
		counryCode: 'NO',
		phoneCode: '+47',
		name: 'Norway',
		currency: 'NOK'
	},
	{
		counryCode: 'OM',
		phoneCode: '+968',
		name: 'Oman',
		currency: 'OMR'
	},
	{
		counryCode: 'PK',
		phoneCode: '+92',
		name: 'Pakistan',
		currency: 'PKR'
	},
	{
		counryCode: 'PW',
		phoneCode: '+680',
		name: 'Palau',
		currency: 'USD'
	},
	{
		counryCode: 'PS',
		phoneCode: '+970',
		name: 'Palestinian Territory, Occupied',
		currency: 'ILS'
	},
	{
		counryCode: 'PA',
		phoneCode: '+507',
		name: 'Panama',
		currency: 'PAB'
	},
	{
		counryCode: 'PG',
		phoneCode: '+675',
		name: 'Papua New Guinea',
		currency: 'PGK'
	},
	{
		counryCode: 'PY',
		phoneCode: '+595',
		name: 'Paraguay',
		currency: 'PYG'
	},
	{
		counryCode: 'PE',
		phoneCode: '+51',
		name: 'Peru',
		currency: 'PEN'
	},
	{
		counryCode: 'PH',
		phoneCode: '+63',
		name: 'Philippines',
		currency: 'PHP'
	},
	{
		counryCode: 'PL',
		phoneCode: '+48',
		name: 'Poland',
		currency: 'PLN'
	},
	{
		counryCode: 'PT',
		phoneCode: '+351',
		name: 'Portugal',
		currency: 'EUR'
	},
	{
		counryCode: 'PR',
		phoneCode: '+1787',
		name: 'Puerto Rico',
		currency: 'USD'
	},
	{
		counryCode: 'QA',
		phoneCode: '+974',
		name: 'Qatar',
		currency: 'QAR'
	},
	{
		counryCode: 'CG',
		phoneCode: '+242',
		name: 'Republic Of Congo',
		currency: 'XAF'
	},
	{
		counryCode: 'RE',
		phoneCode: '+262',
		name: 'Reunion',
		currency: 'EUR'
	},
	{
		counryCode: 'RO',
		phoneCode: '+40',
		name: 'Romania',
		currency: 'RON'
	},
	{
		counryCode: 'RU',
		phoneCode: '+7',
		name: 'Russian Federation',
		currency: 'RUB'
	},
	{
		counryCode: 'RU',
		phoneCode: '+8',
		name: 'Russian Federation',
		currency: 'RUB'
	},
	{
		counryCode: 'RW',
		phoneCode: '+250',
		name: 'Rwanda',
		currency: 'RWF'
	},
	{
		counryCode: 'BL',
		phoneCode: '+590',
		name: 'Saint Barthélemy',
		currency: 'EUR'
	},
	{
		counryCode: 'SH',
		phoneCode: '+290',
		name: 'Saint Helena, Ascension And Tristan Da Cunha',
		currency: 'SHP'
	},
	{
		counryCode: 'MF',
		phoneCode: '+590',
		name: 'Saint Martin',
		currency: 'EUR'
	},
	{
		counryCode: 'PM',
		phoneCode: '+508',
		name: 'Saint Pierre And Miquelon',
		currency: 'EUR'
	},
	{
		counryCode: 'WS',
		phoneCode: '+685',
		name: 'Samoa',
		currency: 'WST'
	},
	{
		counryCode: 'SM',
		phoneCode: '+378',
		name: 'San Marino',
		currency: 'EUR'
	},
	{
		counryCode: 'SA',
		phoneCode: '+966',
		name: 'Saudi Arabia',
		currency: 'SAR'
	},
	{
		counryCode: 'RS',
		phoneCode: '+381',
		name: 'Serbia',
		currency: 'RSD'
	},
	{
		counryCode: 'SC',
		phoneCode: '+248',
		name: 'Seychelles',
		currency: 'SCR'
	},
	{
		counryCode: 'SL',
		phoneCode: '+232',
		name: 'Sierra Leone',
		currency: 'SLL'
	},
	{
		counryCode: 'SG',
		phoneCode: '+65',
		name: 'Singapore',
		currency: 'SGD'
	},
	{
		counryCode: 'SX',
		phoneCode: '+1721',
		name: 'Sint Maarten',
		currency: 'ANG'
	},
	{
		counryCode: 'SK',
		phoneCode: '+421',
		name: 'Slovakia',
		currency: 'EUR'
	},
	{
		counryCode: 'SI',
		phoneCode: '+386',
		name: 'Slovenia',
		currency: 'EUR'
	},
	{
		counryCode: 'SB',
		phoneCode: '+677',
		name: 'Solomon Islands',
		currency: 'SBD'
	},
	{
		counryCode: 'SO',
		phoneCode: '+252',
		name: 'Somalia',
		currency: 'SOS'
	},
	{
		counryCode: 'ES',
		phoneCode: '+34',
		name: 'Spain',
		currency: 'EUR'
	},
	{
		counryCode: 'LK',
		phoneCode: '+94',
		name: 'Sri Lanka',
		currency: 'LKR'
	},
	{
		counryCode: 'SD',
		phoneCode: '+249',
		name: 'Sudan',
		currency: 'SDG'
	},
	{
		counryCode: 'SR',
		phoneCode: '+597',
		name: 'Suriname',
		currency: 'SRD'
	},
	{
		counryCode: 'SJ',
		phoneCode: '+47',
		name: 'Svalbard And Jan Mayen',
		currency: 'NOK'
	},
	{
		counryCode: 'SE',
		phoneCode: '+46',
		name: 'Sweden',
		currency: 'SEK'
	},
	{
		counryCode: 'CH',
		phoneCode: '+41',
		name: 'Switzerland',
		currency: 'CHF'
	},
	{
		counryCode: 'SY',
		phoneCode: '+963',
		name: 'Syrian Arab Republic',
		currency: 'SYP'
	},
	{
		counryCode: 'TW',
		phoneCode: '+886',
		name: 'Taiwan, Province Of China',
		currency: 'TWD'
	},
	{
		counryCode: 'TJ',
		phoneCode: '+992',
		name: 'Tajikistan',
		currency: 'TJS'
	},
	{
		counryCode: 'TZ',
		phoneCode: '+255',
		name: 'Tanzania, United Republic Of',
		currency: 'TZS'
	},
	{
		counryCode: 'TH',
		phoneCode: '+66',
		name: 'Thailand',
		currency: 'THB'
	},
	{
		counryCode: 'TK',
		phoneCode: '+690',
		name: 'Tokelau',
		currency: 'NZD'
	},
	{
		counryCode: 'TO',
		phoneCode: '+676',
		name: 'Tonga',
		currency: 'TOP'
	},
	{
		counryCode: 'TT',
		phoneCode: '+1868',
		name: 'Trinidad And Tobago',
		currency: 'TTD'
	},
	{
		counryCode: 'TN',
		phoneCode: '+216',
		name: 'Tunisia',
		currency: 'TND'
	},
	{
		counryCode: 'TR',
		phoneCode: '+90',
		name: 'Turkey',
		currency: 'TRY'
	},
	{
		counryCode: 'TM',
		phoneCode: '+993',
		name: 'Turkmenistan',
		currency: 'TMT'
	},
	{
		counryCode: 'TC',
		phoneCode: '+1649',
		name: 'Turks And Caicos Islands',
		currency: 'USD'
	},
	{
		counryCode: 'TV',
		phoneCode: '+688',
		name: 'Tuvalu',
		currency: 'AUD'
	},
	{
		counryCode: 'UG',
		phoneCode: '+256',
		name: 'Uganda',
		currency: 'UGX'
	},
	{
		counryCode: 'UA',
		phoneCode: '+380',
		name: 'Ukraine',
		currency: 'UAH'
	},
	{
		counryCode: 'AE',
		phoneCode: '+971',
		name: 'United Arab Emirates',
		currency: 'AED'
	},
	{
		counryCode: 'GB',
		phoneCode: '+1473',
		name: 'United Kingdom',
		currency: 'GBP'
	},
	{
		counryCode: 'US',
		phoneCode: '+1',
		name: 'United States',
		currency: 'USD'
	},
	{
		counryCode: 'UZ',
		phoneCode: '+998',
		name: 'Uzbekistan',
		currency: 'UZS'
	},
	{
		counryCode: 'VU',
		phoneCode: '+678',
		name: 'Vanuatu',
		currency: 'VUV'
	},
	{
		counryCode: 'VA',
		phoneCode: '+379',
		name: 'Vatican City State',
		currency: 'EUR'
	},
	{
		counryCode: 'VN',
		phoneCode: '+84',
		name: 'Viet Nam',
		currency: 'VND'
	},
	{
		counryCode: 'VG',
		phoneCode: '+1284',
		name: 'Virgin Islands (British)',
		currency: 'USD'
	},
	{
		counryCode: 'VI',
		phoneCode: '+1340',
		name: 'Virgin Islands (US)',
		currency: 'USD'
	},
	{
		counryCode: 'EH',
		phoneCode: '+212',
		name: 'Western Sahara',
		currency: 'MAD'
	},
	{
		counryCode: 'YE',
		phoneCode: '+967',
		name: 'Yemen',
		currency: 'YER'
	},
	{
		counryCode: 'ZM',
		phoneCode: '+260',
		name: 'Zambia',
		currency: 'ZMW'
	},
	{
		counryCode: 'ZW',
		phoneCode: '+263',
		name: 'Zimbabwe',
		currency: 'ZWL'
	}
];
